import { Link } from "react-router-dom"
import {MapPin, Phone, Mail, Instagram, Heart, ArrowUpRight} from 'lucide-react'
import { brandName, contactEmail, contactPhone, fullAddress, images, instagramHandle, instagramUrl, practitionerName, profession } from "@/data/site"

function Footer() {
  return (
    <footer className="border-t border-[#4a3b31] bg-[#33261f] text-[#f7f3ed]">
      <div className="mx-auto grid max-w-6xl gap-10 px-5 py-14 md:grid-cols-[1.4fr_1fr_1fr] md:px-8">
        <div>
          <div className="flex items-center gap-3.5">
            {images.logo ? (
              <img
                src={images.logo}
                alt={`Logo ${brandName}`}
                loading="lazy"
                className="h-12 w-12 rounded-full bg-[#fbf7f1] p-1 object-contain drop-shadow"
              />
            ) : null}
            <div>
              <p className="font-display text-2xl font-medium tracking-tight text-[#fdfbf7]">{brandName}</p>
              <p className="text-[11px] uppercase tracking-[0.2em] text-[#d69f88]">{practitionerName} · {profession}</p>
            </div>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#cbbab0]">
            Accompagnement périnatal à Inguiniel et à domicile. Présence, écoute et soutien chaleureux pour cheminer sereinement.
          </p>
        </div>

        <div>
          <p className="text-xs font-medium uppercase tracking-[0.2em] text-[#d69f88]">Explorer</p>
          <div className="mt-4 flex flex-col gap-2.5 text-sm">
            <Link to="/a-propos" className="text-[#cbbab0] transition-colors hover:text-[#fbf7f2]">Qui suis-je ?</Link>
            <Link to="/accompagnement-doula" className="text-[#cbbab0] transition-colors hover:text-[#fbf7f2]">Accompagnement Doula</Link>
            <Link to="/prestations-maman" className="text-[#cbbab0] transition-colors hover:text-[#fbf7f2]">Prestations Maman</Link>
            <Link to="/prestations-bebe" className="text-[#cbbab0] transition-colors hover:text-[#fbf7f2]">Prestations Bébé</Link>
            <Link to="/faq" className="text-[#cbbab0] transition-colors hover:text-[#fbf7f2]">FAQ</Link>
            <Link to="/cgv" className="text-[#cbbab0] transition-colors hover:text-[#fbf7f2]">CGV</Link>
            <Link to="/planning-ateliers" className="text-[#cbbab0] transition-colors hover:text-[#fbf7f2]">Planning ateliers</Link>
            <Link to="/carte-cadeau" className="text-[#cbbab0] transition-colors hover:text-[#fbf7f2]">Carte Cadeau</Link>
            <Link to="/contact" className="text-[#cbbab0] transition-colors hover:text-[#fbf7f2]">Contact</Link>
          </div>
        </div>

        <div className="flex flex-col justify-between">
          <div>
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-[#d69f88]">Contact & Échanges</p>
            <div className="mt-4 space-y-2.5 text-sm text-[#cbbab0]">
              <p className="flex items-center gap-2">
                <MapPin size={15} className="text-[#d69f88] shrink-0" />
                <span>{fullAddress}</span>
              </p>
              <p>
                <a href={`mailto:${contactEmail}`} className="flex items-center gap-2 transition-colors hover:text-[#fdfbf7]">
                  <Mail size={15} className="text-[#d69f88] shrink-0" />
                  <span>{contactEmail}</span>
                </a>
              </p>
              <p>
                <a href={`tel:${contactPhone.replace(/\s+/g, '')}`} className="flex items-center gap-2 transition-colors hover:text-[#fdfbf7]">
                  <Phone size={15} className="text-[#d69f88] shrink-0" />
                  <span>{contactPhone}</span>
                </a>
              </p>
              {instagramHandle ? (
                <p>
                  <a
                    href={instagramUrl || `https://instagram.com/${instagramHandle.replace("@", "")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 transition-colors hover:text-[#fdfbf7]"
                  >
                    <Instagram size={15} className="text-[#d69f88] shrink-0" />
                    <span>{instagramHandle}</span>
                    <ArrowUpRight size={12} className="opacity-70" />
                  </a>
                </p>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-5 py-5 text-xs text-[#a8988e] md:flex-row md:px-8">
          <p>
            © {new Date().getFullYear()} {brandName} – {practitionerName}. Tous droits réservés.
          </p>
          <p className="flex items-center gap-1.5 text-[11px]">
            <span>Présence · Écoute · Confidentialité</span>
            <Heart size={11} className="text-[#d69f88] fill-[#d69f88]/40 inline" />
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
